<template>
  <el-table
    :data="list"
    stripe
    v-loading="loading"
    @selection-change="handleSelectionChange"
  >
    <template v-for="column in tableColumns">
      <el-table-column  :key="column.props" v-if="column.props === 'selection'" type="selection" :width="column.width" :align="column.align"></el-table-column>
      <!-- TODO: 待优化 -->
        <el-table-column
          v-else
          :prop="column.props"
          :align="column.align ||'left'"
          :label="column.label"
          :width="column.width"
          :min-width="column.minWidth"
          :fixed="column.fixed"
        >
          <template slot-scope="{row}">
            <slot :name="column.props" :row="row">
              <div v-if="column.props === 'orderId'" @click.stop.prevent="toOrderList(row)" style="color: #409EFF; cursor: pointer;">
                {{ row.orderId || '' }}
              </div>
              <div v-else>
                {{ formatterColumnData(row, column) }}
              </div>
            </slot>
          </template>
        </el-table-column>
    </template>
  </el-table>
</template>
<script>
import { 
  genderMap,
  StatusMap,
  conditionSelectionMap
} from '../static/form-options';

const formatCondition = (row, props) => {
  return conditionSelectionMap.get(row[props])
}

const columns = Object.freeze([
  { props: 'name', label: '姓名', minWidth: 120, fixed: 'left' },
  { props: 'gender', label: '性别', formatter: (row, props) => genderMap.get(row[props])},
  { props: 'mobile', label: '手机号', minWidth: 160 },
  { props: 'customerSource', label: '客户来源', width: 120 },
  // { props: 'firstTouchChannel', label: '首触渠道', width: 120 },
  { props: 'arrivalType', label: '到店类型', width: 120 },
  { props: 'arrivalTime', label: '到店时间', minWidth: 160 },
  { props: 'receptionStaff', label: '接待人员' },
  { props: 'intentionSeries', label: '意向车系', minWidth: 160 },
  { props: 'isReplacement', label: '是否置换', formatter: formatCondition },
  { props: 'isTestDrive', label: '是否试驾', formatter: formatCondition },
  { props: 'orderId', label: '关联订单', width: 120 },
  { props: 'isAutoCreate', label: '是否自动创建', formatter: formatCondition, width: 100 },
  { props: 'hasBook', label: '是否订车', formatter: formatCondition },
  { props: 'hasDeliver', label: '是否交车', formatter: formatCondition },
  { props: 'status', label: '状态', formatter: (row, props) => StatusMap.get(row[props]) },
  { props: 'operation', label: '操作', width: 100, fixed: 'right' },
])

export default {
  name: 'CustomerFlowList',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      tableColumns: columns
    }
  },
  methods: {
    formatterColumnData(row, column) {
      if (typeof column.formatter ===  'function') {
        return column.formatter(row, column.props)
      }
      return row[column.props]
    },
    // 勾选选择框
    handleSelectionChange(val){
      console.log(val, 'handleSelectionChange===')
    },
    // 跳到订单列表
    toOrderList(row) {
      if (row.orderId) {
        this.$router.push({
          path: '/order/zzOrder',
          query: {
            orderId: row.orderId
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>